{
  "title": "Suivi d'activité FBO",
  "comingSoonTitle": "Bientôt",
  "comingSoonDescription": "Cette fonctionnalité affichera le suivi d'activité pour chaque compte FBO.",
  "fboAccountsTitle": "Comptes FBO ({{count}}) :",
  "activityDataComingSoon": "Données d'activité à venir"
}
